<template>
  <div class="ivy-player-container">
    <button class="ivy-btn-play" v-if="!playing" @click="play"></button>
    <video
      class="ivy-media"
      ref="media"
      @timeupdate="timeupdate"
      :src="src"
      :poster="poster"
      preload="meta"
      width="100%"
      height="100%"
      :controls="false"
      controlslist="nodownload"
      :loop="loop"
      @click.stop="pause"
    ></video>
    <!-- webkit-playsinline="true"
   style="object-fit:fill"
  x-webkit-airplay="allow"
  x5-video-orientation="landscape|portrait"
  playsinline="true"
  x5-video-player-type="h5"
  x5-video-player-fullscreen="true" landscape|portrait -->
    <div class="ivy-media-controls" v-if="ipad || isMix2s">
      <button class="btn-play" v-if="!playing" @click="play">&#xe629;</button>
      <button class="btn-pause" v-else @click="pause">&#xe64b;</button>
      <div class="media-updatetime">
        {{ Date.formatMs(currentTime * 1000, 'mm:ss') || '00:00' }}
      </div>
      <div class="media-progress">
        <vueSlider
          class="progress"
          tooltip
          @callback="changeSlider($event)"
          :height="slider.height"
          :dot-size="slider.dotSize"
          :bg-style="slider.bgStyle"
          :process-style="slider.processStyle"
          :slider-style="slider.sliderStyle"
          ref="slider"
          v-model="slider.curValue"
        />
      </div>
      <div class="media-time">
        {{ Date.formatMs(duration * 1000, 'mm:ss') || '00:00' }}
      </div>
      <!-- <button class="btn-full" v-if="ipad && !full" @click="requestFullscreen">&#xe7f7;</button>
    <button class="btn-exitfull" v-if="ipad && full" @click="cancelFullscreen">&#xe60d;</button> -->
    </div>
  </div>
</template>
<script>
import vueSlider from 'vue-slider-component'
import { sleep, isWeixin, getOs } from '@ivy/fts/utils'
export default {
  components: { vueSlider },
  props: ['src', 'poster', 'loop', 'isRichText'],
  data() {
    return {
      ipad: false,
      isMix2s: false,
      full: false,
      dir: 'horizontal', // 屏幕方向
      container: null,
      playing: false, // 是否正在播放
      duration: 0,
      currentTime: 0,
      slider: {
        // 控制进度条部分
        // direction: this.ios && this.full ? 'vertical' : 'horizontal',
        curValue: 1,
        height: 2,
        dotSize: 14,
        bgStyle: {
          backgroundColor: 'rgba(255, 255, 255, 0.6)',
          height: '2px',
        },
        processStyle: {
          backgroundColor: '#da277c',
        },
        sliderStyle: {
          backgroundColor: '#da277c',
          boxShadow: 'none',
        },
      },
    }
  },
  async mounted() {
    let ua = navigator.userAgent.toLowerCase()
    this.ipad = ua.match(/iPad/i) === 'ipad' || window.innerWidth >= 768
    this.isMix2s =
      ua.includes('mix') ||
      ua.includes('mix 2s') ||
      ua.includes('MIX 2S') ||
      ua.includes('10.2')
    this.container = document.querySelector('.ivy-player-container')
    // 设置音量大小为0.5
    // x5-video-orientation=landscape|portrait 横屏|竖屏 根据系统自动旋转
    // this.media.volume = 0.5
    this.$refs.media.addEventListener('play', () => {
      this.playing = true
      this.$emit('on-play')
    })
    this.$refs.media.addEventListener('pause', () => {
      this.playing = false
      this.$emit('on-pause')
    })
    this.$refs.media.addEventListener('stop', () => {
      this.playing = false
      this.$emit('on-stop')
    })
    this.$refs.media.addEventListener('ended', async () => {
      console.log('playend')
      this.$emit('on-playend')
      this.playing = false
      this.exitFullscreen(this.$refs.media)
    })
    let evt = 'onorientationchange' in window ? 'orientationchange' : 'resize'
    // window.addEventListener(evt, () => {
    //   // 暂时先退出全屏
    //   return this.cancelFullscreen()
    //   if (this.ios && this.playing) {
    //     if (window.orientation == 180 || window.orientation == 0) {
    //       this.$Toast('已开启竖屏')
    //       this.dir = 'horizontal'
    //       return this.iosFullscreen()
    //     }
    //     if (window.orientation == 90 || window.orientation == -90) {
    //       this.$Toast('已开启横屏')
    //       this.dir = 'vertical'
    //       return this.iosFullscreen()
    //     }
    //   }
    // })
    // let opt = {
    //   proload: 'auto',
    //   'x-webkit-airplay': 'allow',
    //   'x5-video-player-type': 'h5',
    //   'x5-video-player-fullscreen': true,
    //   'x5-video-orientation': 'portraint',
    //   'webkit-playsinline': true,
    //   playsinline: true,
    //   style: 'object-fit:fill;position:absolute',
    // }
  },
  methods: {
    exitFullscreen(videoBoj) {
      getOs() === 'android'
        ? this.isRichText
          ? (() => {})()
          : (videoBoj.srcObject = new window.webkitMediaStream())
        : videoBoj.webkitExitFullScreen()
    },
    async toggleControls() {
      this.controlsHide = !this.controlsHide
    },
    setElementAttr(ele, option) {
      for (let key in option) {
        if (ele) {
          ele.setAttribute(key, option[key])
        }
      }
      return ele
    },
    async play() {
      this.$emit('play')
      let playFn = () => {
        // this.iosFullscreen()
        let playPromise = this.$refs.media.play()
        // this.requestFullscreen(this.media)
        if (playPromise !== undefined) {
          playPromise.catch(error => {}).then(() => {})
        }
      }
      if (isWeixin()) {
        document.addEventListener('WeixinJSBridgeReady', playFn(), false)
      } else {
        console.log('is chrome')
        playFn()
      }
    },
    pause() {
      this.$refs.media.pause()
      // this.playing = false
    },
    timeupdate(ev) {
      this.duration = ev.target.duration
      this.currentTime = ev.target.currentTime
      this.slider.curValue = Math.floor(
        (this.currentTime / this.duration) * 100
      )
      if (+this.slider.curValue % 5 === 0) {
        this.$emit('playTimeUpdate', this.slider.curValue)
      }
    },
    changeSlider(ev) {
      let pos = Math.floor(this.duration / (100 / ev))
      this.$refs.media.currentTime = pos
    },
    async iosFullscreen() {
      // dir为vertical是横屏 为horizontal是竖屏 默认是horizontal竖屏
      if (this.ios) {
        let width = window.innerWidth
        let height = window.innerHeight
        let element = this.container
        element.style.position = 'fixed'
        element.style.zIndex = '999'
        if (width > height) {
          element.style.transform =
            this.dir === 'horizontal' ? 'rotate(90deg)' : 'rotate(0deg)'
          element.style.width = `${width}px`
          element.style.height = `${height}px`
          element.style.top =
            this.dir === 'horizontal' ? `${(width - height) / 2}px` : '0px'
          element.style.left =
            this.dir === 'horizontal' ? `${(height - width) / 2}px` : '0px'
        } else {
          element.style.transform =
            this.dir === 'vertical' ? 'rotate(0deg)' : 'rotate(90deg)'
          element.style.width = `${height}px`
          element.style.height = `${width}px`
          element.style.top =
            this.dir === 'vertical' ? '0px' : `${(height - width) / 2}px`
          element.style.left =
            this.dir === 'vertical' ? '0px' : `${(width - height) / 2}px`
        }
        this.full = true
      }
    },
    async requestFullscreen(elem = this.$refs.media) {
      await this.$nextTick()
      // if (this.ios) {
      this.full = true
      //   return this.iosFullscreen()
      // }
      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen()
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen()
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen()
      }
    },
    async cancelFullscreen() {
      await this.$nextTick()
      // if (this.ios) {
      this.full = false
      //   return this.container.removeAttribute('style')
      // }
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.oRequestFullscreen) {
        document.oCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    },
  },
}
</script>
<style lang="less">
@import (reference) url(../../project.less);
@font-face {
  font-family: 'iconfontPlayer'; /* project id 753392 */
  src: url('//at.alicdn.com/t/font_753392_8xd7ow9qyac.eot');
  src: url('//at.alicdn.com/t/font_753392_8xd7ow9qyac.eot?#iefix')
      format('embedded-opentype'),
    url('//at.alicdn.com/t/font_753392_8xd7ow9qyac.woff') format('woff'),
    url('//at.alicdn.com/t/font_753392_8xd7ow9qyac.ttf') format('truetype'),
    url('//at.alicdn.com/t/font_753392_8xd7ow9qyac.svg#iconfont') format('svg');
}
.iconfontPlayer {
  font-family: 'iconfontPlayer' !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
button {
  color: #fff;
}
.tranAnimate(@ms: 0.2s) {
  transition-duration: @ms;
  -webkit-transition-duration: @ms;
  -moz-transition-duration: @ms;
  -o-transition-duration: @ms;
}
.ivy-player-container {
  position: relative;
  width: 100%;
  height: 450px;
  // background-color: #000;
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
  .tranAnimate(0.2s);
  .ivy-btn-play,
  .ivy-btn-pause {
    // .iconfontPlayer;
    // .image-cover;
    position: absolute;
    border-radius: 50%;
    width: 90px;
    height: 90px;
    // font-size: 40px;
    left: 50%;
    top: 50%;
    margin-left: -45px;
    margin-top: -45px;
    z-index: 99;
    background-image: url(../../assets/playCover7.png);
    background-size: 100% 100%;
  }
  video::-webkit-media-controls {
    overflow: hidden !important;
  }
  video::-webkit-media-controls-panel {
    display: none!important;
    -webkit-appearance: none;
  }

  video::--webkit-media-controls-play-button {
    display: none!important;
    -webkit-appearance: none;
  }

  video::-webkit-media-controls-start-playback-button {
    display: none!important;
    -webkit-appearance: none;
  }

  // video::-webkit-media-controls-enclosure {
  //   width: calc(100% + 111px);
  //   margin-left: auto;
  // }
  .ivy-media {
    width: 100%;
    height: 100%;
  }
  .ivy-media-controls {
    display: none !important;
    transform: rotate(0);
    position: absolute;
    height: 66px;
    background-color: rgba(0, 0, 0, 0.6);
    left: 0;
    right: 0;
    bottom: 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-wrap: wrap;
    align-items: center;
    .btn-play,
    .btn-pause,
    .btn-full,
    .btn-exitfull {
      .iconfontPlayer;
      width: 66px;
      height: 66px;
      font-size: 32px;
    }
    .media-updatetime,
    .media-time {
      height: 66px;
      font: 18px/66px Arial, Helvetica, sans-serif;
      color: #fff;
      width: 70px;
      text-align: center;
    }
    .media-progress {
      flex: 1;
    }
  }
}
// @media screen and (min-width: 768px) {
//   .ivy-player-container{
//     height: 187px;
//     .ivy-btn-play, .ivy-btn-pause{
//       width: 53px;
//       height: 53px;
//       font-size: 20px;
//       margin-left: -26.5px;
//       margin-top: -26.5px;
//     }
//     .ivy-media-controls{
//       height: 33px;
//       .btn-play, .btn-pause, .btn-full, .btn-exitfull{
//         width: 33px;
//         height: 33px;
//         font-size: 16px;
//       }
//       .media-updatetime, .media-time{
//         height: 33px;
//         font: 9px/33px Arial,Helvetica,sans-serif;
//         width: 35px;
//       }
//     }
//   }
// }
</style>
